module.exports = __webpack_public_path__ + "img/37_36.c904c15c.png";